'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'hand';
var width = 512;
var height = 512;
var aliases = [129306,9995,"hand-paper"];
var unicode = 'f256';
var svgPathData = ['M25.4 273.4c-12.5 12.5-12.5 32.8 0 45.3L137.1 430.4c42 42 99 65.6 158.4 65.6l8.5 0c83.9 0 152-68.1 152-152l0-200c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-168c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 168c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-200c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 200c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-168c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 255.4c0 3.2-1.9 6.2-4.9 7.4s-6.4 .6-8.7-1.7L70.6 273.4c-12.5-12.5-32.8-12.5-45.3 0z', 'M232 48l0 200c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-168c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 255.4c0 3.2-1.9 6.2-4.9 7.4s-6.4 .6-8.7-1.7L70.6 273.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L137.1 430.4c42 42 99 65.6 158.4 65.6l8.5 0c83.9 0 152-68.1 152-152l0-200c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 104c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-168c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 168c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-200c0-17.7-14.3-32-32-32s-32 14.3-32 32zM264 0c25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48l0 28.2c8.5-7.6 19.7-12.2 32-12.2 26.5 0 48 21.5 48 48l0 200c0 92.8-75.2 168-168 168l-8.5 0c-63.7 0-124.7-25.3-169.7-70.3L14.1 329.9c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L136 316.1 136 80c0-26.5 21.5-48 48-48 12.4 0 23.6 4.7 32.1 12.3 1.9-24.8 22.6-44.3 47.9-44.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHand = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;